import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MydacComponent } from './mydac/mydac.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { ComplianceReviewComponent } from './compliance-review/compliance-review.component';
import { ArchivedcurrentdocumentsComponent } from './archivedcurrentdocuments/archivedcurrentdocuments.component';
import { ContinuingeducationComponent } from './continuingeducation/continuingeducation.component';
import { DmcaComponent } from './dmca/dmca.component';
import { LegalInformationComponent } from './LegalInformation/legal-information.component';
import { AboutusComponent } from './aboutus/aboutus.component';
import { HelpComponent } from './help/help.component';
import { SitemapComponent } from './sitemap/sitemap.component';
import { BrowseObligorComponent } from './browse-obligor/browse-obligor.component';
import { BrowseobligorService } from './services/browseobligor.service';
import { IssuersandObligorsComponent } from './IssuersandObligors/issuersand-obligors.component';
import { DACForInvestorsComponent } from './DACForInvestors/dacfor-investors.component';
import { ReviewtoolkitComponent } from './reviewtoolkit/reviewtoolkit.component';
import { LoginComponent } from './login/login.component';
import { CusipComponent } from './cusip/cusip.component';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';
import { PandpcusipComponent } from './pandpcusip/pandpcusip.component';
import { MustMatchDirective } from './_helpers/must-match.directive';
import { from } from 'rxjs';


@NgModule({
  declarations: [
    AppComponent,
    MydacComponent,
    HeaderComponent,
    FooterComponent,
    ComplianceReviewComponent,
    DmcaComponent,
    LegalInformationComponent,
    AboutusComponent,
    HelpComponent,
    SitemapComponent,
    ArchivedcurrentdocumentsComponent,
    ContinuingeducationComponent,
    BrowseObligorComponent,

    IssuersandObligorsComponent,
    DACForInvestorsComponent,

    ReviewtoolkitComponent,
    LoginComponent,
    CusipComponent,
    ForgotpasswordComponent,
    ResetpasswordComponent,
    PandpcusipComponent,
    MustMatchDirective
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    HttpClientModule,
    FormsModule,
    AppRoutingModule
   ],
  providers: [BrowseobligorService, { provide: LocationStrategy, useClass: HashLocationStrategy }],
  bootstrap: [AppComponent]
})
export class AppModule { }
